module.exports = __webpack_public_path__ + "img/true360-report-spread.3403e50b.png";